import { FC, useEffect, useState } from 'react'
import { CardStyle } from './style'

type CardProps = {
  content: React.ReactNode,
  animationOrder: number
  animationTime?: number
}

const Card: FC<CardProps> = props => {
  const { content, animationOrder, animationTime = 100 } = props
  const [isDisplay, setDisplay] = useState(false)

  useEffect(() => {
    if (animationOrder) {
      setTimeout(() => {
        setDisplay(true)
      }, animationTime * animationOrder)
    } else {
      setDisplay(true)
    }
  }, [])

  return (
    <CardStyle $isDisplay={isDisplay}>
      <div className='card'>{content}</div>
    </CardStyle>
  )
}

export default Card